/*
 * Copyright (c) 2023 Bluemate B.V.
 */

import IDate from '@dvrd/idate';
import {UnlayerMergeTags} from './interfaces';
import Account from '../models/accountModel';
import {getCustomVariables} from './pdfUtil';

export function getMergeTags(account: Account | null): UnlayerMergeTags {
    const {client, company, invoice} = getCustomVariables();
    const companyTags: UnlayerMergeTags = {};
    const clientTags: UnlayerMergeTags = {};
    const invoiceTags: UnlayerMergeTags = {};
    for (const [value, name] of Object.entries(company)) {
        companyTags[name] = {name, value: `{${value}}`, sample: getSample(value, account)};
    }
    for (const [value, name] of Object.entries(client)) {
        clientTags[name] = {name, value: `{${value}}`, sample: getSample(value, account)};
    }
    for (const [value, name] of Object.entries(invoice)) {
        invoiceTags[name] = {name, value: `{${value}}`, sample: getSample(value, account)};
    }
    const productTags: UnlayerMergeTags = {
        productName: {name: 'Productnaam', value: '{product_title}'},
        imageURL: {name: 'Afbeelding URL', value: '{product_image}'},
        reviewURL: {name: 'Review URL', value: '{product_url}'},
        ean: {name: 'EAN', value: '{ean}'}
    };
    return {
        company: {name: 'Bedrijf', mergeTags: companyTags},
        custmer: {name: 'Klant', mergeTags: clientTags},
        invoice: {name: 'Factuur', mergeTags: invoiceTags},
        product: {name: 'Product', mergeTags: productTags}
    };
}

function getSample(value: string, account: Account | null): string {
    if (account) {
        if (value === 'bedrijf_naam') return account.companyName;
        else if (value === 'bedrijf_adres') return account.address;
        else if (value === 'bedrijf_postcode') return account.zipCode;
        else if (value === 'bedrijf_stad') return account.city;
        else if (value === 'bedrijf_land') return account.country;
        else if (value === 'bedrijf_email') return account.email;
        else if (value === 'bedrijf_telefoon') return account.telNumber;
        else if (value === 'bedrijf_iban') return account.iban;
        else if (value === 'bedrijf_btw') return account.vatNumber;
        else if (value === 'bedrijf_kvk') return account.cocNumber;
        else if (value === 'factuurnummer') return account.settings.invoicePrefix + account.settings.invoiceStart;
    }
    const samples: Record<string, string> = {
        klant_naam: 'John Doe',
        klant_voornaam: 'John',
        klant_achternaam: 'Doe',
        datum: IDate.now().format('DD-MM-YYYY'),
        factuurdatum: IDate.now().format('DD-MM-YYYY'),
        order_id: '12345678'
    };
    return samples[value] ?? value;
}
